import styled, { createGlobalStyle } from 'styled-components';
import Autocomplete from '@material-ui/lab/Autocomplete';
export const AutocompleteGlobalStyles = createGlobalStyle `
  .MuiAutocomplete-option[aria-selected="true"] {
    background-color: ${({ theme }) => theme.colors.primary}1a !important;
    border-left: 3px solid ${({ theme }) => theme.colors.primary};
    font-weight: 600;
  }
  .MuiAutocomplete-option[aria-selected="true"]:hover {
    background-color: ${({ theme }) => theme.colors.primary}33 !important;
  }
`;
export const $Autocomplete = styled(Autocomplete) `
  .MuiInputBase-root {
    width: 100%;
    cursor: pointer;
  }
  .MuiInputBase-input {
    cursor: pointer;
  }
`;
